import Card from "components/card";
import OrderStep from "components/dataDisplay/OrderStep";
import {
  MdPointOfSale,
  MdShoppingBasket,
  MdArchive,
  MdLocalShipping,
  MdCheckCircle,
  MdPayment,
  MdSchool,
  MdAccessTime,
} from "react-icons/md";
import { MdCheck, MdTimer } from "react-icons/md";

const OrderStatus = ({ orderData }) => {
  const { status, paymentMethod, createdAt, paymentDate, expirationDate } = orderData || {};

  // Determine current step based on status
  const getCurrentStep = () => {
    switch (status) {
      case 'active':
        return 4; // Completed
      case 'pending':
        return paymentDate ? 3 : 2; // Payment confirmed or pending
      case 'expired':
        return 5; // Expired
      case 'canceled':
        return 0; // Cancelled
      default:
        return 1; // Default to first step
    }
  };

  const currentStep = getCurrentStep();

  return (
    <Card extra={"w-full h-full p-4"}>
      {/* Order Status */}
      <h4 className="mt-1 text-lg font-semibold text-navy-700 dark:text-white">
        Subscription Status
      </h4>

      {/* ordersteps */}
      <div className="relative h-full w-full">
        <div
          className={`absolute left-[32px] mt-20 text-brand-500 dark:text-white`}
        >
          <svg
            width="2"
            height="130"
            viewBox="0 0 2 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1"
              y1="63"
              x2="0.999997"
              y2="1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="6 6"
            />
          </svg>
        </div>

        {/* steps */}
        <div className="font-dm font-medium">
          <div>
            <OrderStep
              title="Subscription Created"
              subtitle={new Date(createdAt).toLocaleDateString()}
              bg="bg-white dark:!bg-navy-800"
              icon2={currentStep >= 1 ? <MdCheck /> : <MdTimer />}
              icon={<MdShoppingBasket />}
              border={currentStep >= 1 ? "border-2 border-green-500" : "border-2 border-gray-300"}
            />
          </div>
          <div className="mt-9">
            <OrderStep
              title="Payment Initiated"
              subtitle={paymentMethod === 'Mpesa' ? 'M-Pesa' : paymentMethod}
              bg="bg-white dark:!bg-navy-800"
              icon2={currentStep >= 2 ? <MdCheck /> : <MdTimer />}
              icon={<MdPayment />}
              border={currentStep >= 2 ? "border-2 border-green-500" : "border-2 border-gray-300"}
            />
          </div>
          <div className={`absolute left-[32px] text-brand-500`}>
            <svg
              width="2"
              height="80"
              viewBox="0 0 2 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1"
                y1="63"
                x2="0.999997"
                y2="1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="6 6"
              />
            </svg>
          </div>
          <div className="mt-10">
            <OrderStep
              title="Payment Confirmed"
              subtitle={paymentDate ? new Date(paymentDate).toLocaleDateString() : 'Pending'}
              bg="bg-white dark:!bg-navy-800"
              icon2={currentStep >= 3 ? <MdCheck /> : <MdTimer />}
              icon={<MdPointOfSale />}
              border={currentStep >= 3 ? "border-2 border-green-500" : "border-2 border-gray-300"}
            />
          </div>
          <div
            className={`absolute left-[32px] text-brand-500 dark:text-white`}
          >
            <svg
              width="2"
              height="80"
              viewBox="0 0 2 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1"
                y1="63"
                x2="0.999997"
                y2="1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="6 6"
              />
            </svg>
          </div>
          <div className="mt-10">
            <OrderStep
              title="Access Granted"
              subtitle={expirationDate ? `Expires: ${new Date(expirationDate).toLocaleDateString()}` : 'Active'}
              bg="bg-white dark:!bg-navy-800"
              icon2={currentStep >= 4 ? <MdCheck /> : <MdTimer />}
              icon={<MdSchool />}
              border={currentStep >= 4 ? "border-2 border-green-500" : "border-2 border-gray-300"}
            />
          </div>
          <div className={`absolute left-[32px] text-brand-500`}>
            <svg
              width="2"
              height="80"
              viewBox="0 0 2 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1"
                y1="63"
                x2="0.999997"
                y2="1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="6 6"
              />
            </svg>
          </div>
          <div className="mt-10">
            <OrderStep
              title={status === 'expired' ? 'Subscription Expired' : 'Active'}
              subtitle={status === 'expired' ? 'Renewal required' : 'Fully active'}
              bg={status === 'expired' ? "bg-red-50 dark:!bg-red-900" : "dark:!bg-gradient-to-b from-[#0B1330] dark:!shadow-none to-[#111C44] bg-lightPrimary text-gray-600 shadow-inset shadow-shadow-500"}
              variant="last"
              icon2={status === 'expired' ? <MdTimer className="text-4xl text-red-600" /> : <MdCheckCircle className="text-gray-600" />}
              icon={status === 'expired' ? <MdAccessTime className="text-red-600" /> : <MdCheckCircle className="text-gray-600" />}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default OrderStatus;
